var map = {
	"./AffinityContentPage.tsx": 18782,
	"./AffinityCreateAccountPage.tsx": 42153,
	"./AffinityGetQuotePage.tsx": 90143,
	"./AffinityPlaceOrderPage.tsx": 80788,
	"./AffinitySettings.tsx": 20588,
	"./FunctionalComponentsPage.tsx": 55301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63410;